<template>
  <CustomModal
    id="report-content-modal"
    class="basic-modal"
    :title="$t('common.modal.report_content.title')"
    :close-title="$t('common.cancel')"
    :ok-title="$t('common.confirm')"
    :ok-busy="busy"
    :okDisabled="isEmptyReason"
    @cancel="$emit('cancel')"
    @ok="reportContent()"
  >
    <div
      v-if="selectedReportContentType === 'input'"
      class="input-field-wrapper"
      :class="{ focused: isFocused, 'has-error': isLimitReason }"
    >
      <AutosizeTextarea
        v-model="reason"
        :placeholder="$t('common.modal.report_content.desc')"
        :rows="3"
        @limit="80"
        @focus="isFocused = true"
      />
    </div>
    <template v-if="selectedReportContentType === 'select'">
      <Radio
        id="option-content-has-error"
        :model-value="reportIssue"
        :check-value="1"
        @change="onRadioSelect"
      >
        <span slot="label">
          {{ $t('common.modal.report_content.options.has_error') }}
        </span>
      </Radio>

      <Radio
        id="option-content-is-inappropriate"
        :model-value="reportIssue"
        :check-value="2"
        @:change="onRadioSelect"
      >
        <span slot="label">
          {{ $t('common.modal.report_content.options.inappropriate') }}
        </span>
      </Radio>
    </template>
  </CustomModal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isNil, isEmpty } from 'lodash';

import Mobile from '@/mixins/Mobile';

export default {
  name: 'report-content-modal',

  mixins: [
    Mobile,
  ],

  props: {
    card: {
      type: Object,
      default: null,
    },
    page: {
      type: Object,
      default: null,
    },
    selectedOption: {
      type: Number,
      default: 0,
    },
    answerOption: {
      type: Number,
      default: 0,
    },
    enteredValue: {
      type: String,
      default: '',
    },
    answerValue: {
      type: String,
      default: '',
    },
    quizSolved: {
      type: Boolean,
      default: false,
    },
    isCorrect: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      reportIssue: 1,
      busy: false,
      selectedReportContentType: 'input',
      reason: '',
      isFocused: true,
    };
  },

  computed: {
    ...mapGetters([
      'currentUserId',
      'currentUser',
    ]),

    reportIssueText() {
      if (this.reportIssue === 1) {
        return this.$t('common.modal.report_content.options.has_error');
      }

      return this.$t('common.modal.report_content.options.inappropriate');
    },

    isEmptyReason() {
      return isEmpty(this.reason) || this.reason.length < 2;
    },

    isLimitReason() {
      return this.reason.length > 80;
    },
  },

  methods: {
    ...mapActions([
      'sendContentReport',
    ]),

    onRadioSelect(value) {
      this.reportIssue = value;
    },

    getCardType() {
      if (this.card.type) {
        return this.card.type;
      }

      if (this.card.store_card_id) {
        return 'card';
      }

      if (this.card.card_id) {
        return 'assignment';
      }

      return 'none';
    },

    reportContent() {
      if (this.busy && isNil(this.card) && isNil(this.page)) {
        return;
      }

      this.busy = true;

      const reason = {
        reason: this.reason,
        device: this.getDeviceName(),
        card_type: this.getCardType(),
        pate_type: this.page.page_type.name || '',
        selected_option: this.selectedOption,
        answer_option: this.answerOption,
        entered_value: this.enteredValue,
        answer_value: this.answerValue,
        quiz_solved: this.quizSolved,
        is_correct: this.isCorrect,
      };

      const params = {
        card_id: this.card.copy_id || this.page.card_id || this.card.card_id || null,
        store_card_id: this.card.store_card_id || null,
        card_title: this.card.title || this.page.card_title,
        page_id: this.page.id,
        page_position: this.page.position,
        card_publisher_name: this.card.publisher_name || this.page.publisher_name || null,
        card_publisher_id: this.card.publisher_id || this.page.publisher_id || null,
        card_author_name: this.card.author_name || this.page.author_name || null,
        card_author_id: this.card.author_id || this.page.author_id || null,
        card_subject_id: this.card.subject_id || null,
        card_grade_id: this.card.grade_id || this.page.grade_id || null,
        user_id: this.currentUserId || null,
        user_name: this.currentUser.name || null,
        user_role: this.currentUser.role || null,
        reason: `\`\`\`${JSON.stringify(reason, null, '  ')}\`\`\``,
        reported_from: this.$route.fullPath,
        reported_at: (new Date()).toString(),
      };

      this.sendContentReport(params)
        .then(() => {
          this.busy = false;
          this.$emit('ok');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .input-field-wrapper {
    border-radius: 4px;
    background-color: #ffffff;
    border: solid 1px #cccccc;
    padding: 15px 16px;
    line-height: 18px;
    transition: border-color .5s ease, color .5s ease;

    &.focused {
      border: solid 1px #999999;
    }

    &.has-error {
      border: solid 1px #e91e63;
    }

    textarea {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.29;
      color: rgba(0, 0, 0, 0.87);
      outline: none;
      padding: 0;
      border: none;
      vertical-align: top;
      user-select: auto !important;

      &::placeholder {
        color: #aaaaaa;
      }
    }
  }
</style>
